(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wb-header"]) return;
  try {
    
window.addEventListener('willy:cart:updated', function (event) {
  if (!event.detail) return;
  document.querySelectorAll('.wb-cart-count').forEach(function (badge) {
    badge.textContent = event.detail.item_count;
    badge.style.display = event.detail.item_count > 0 ? '' : 'none';
  });
});
document.addEventListener('click', function (event) {
  if (!event.target.closest('[data-wb-wishlist-open]')) return;
  const dialog = document.getElementById('wb-wishlist-dialog');
  if (!dialog) return;
  let handles = [];
  try { handles = JSON.parse(localStorage.getItem('willy_wishlist') || '[]'); } catch (error) { handles = []; }
  if (!Array.isArray(handles)) handles = [];
  handles = handles.filter(function (handle) { return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle); });
  const list = dialog.querySelector('[data-wb-wishlist-items]');
  list.replaceChildren();
  dialog.querySelector('[data-wb-wishlist-empty]').hidden = handles.length > 0;
  handles.forEach(function (handle) {
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = '/products/' + encodeURIComponent(handle);
    link.textContent = handle.replace(/-/g, ' ');
    item.appendChild(link);
    list.appendChild(item);
  });
  dialog.showModal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["willy-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('dialog[data-willy-popup]').forEach((popup) => {
    if (popup.dataset.initialized || (typeof Shopify !== 'undefined' && Shopify.designMode)) return;
    popup.dataset.initialized = 'true';
    const key = 'willy_popup_dismissed_at';
    const days = Number(popup.dataset.cookieDays) || 14;
    const result = popup.querySelector('[data-popup-result]');
    let dismissed = false;
    let timer;
    let previousOverflow = '';
    let previousFocus;
    try { dismissed = Date.now() - Number(localStorage.getItem(key)) < days * 86400000; } catch {}
    const remember = () => { dismissed = true; try { localStorage.setItem(key, String(Date.now())); } catch {} };
    const open = () => {
      if ((dismissed && !result) || popup.open || !popup.isConnected) return;
      if (document.querySelector('[data-willy-drawer][aria-hidden="false"],dialog[open]') || document.visibilityState === 'hidden') {
        timer = setTimeout(open, 3000);
        return;
      }
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      popup.showModal();
      document.body.style.overflow = 'hidden';
      popup.querySelector('[data-willy-popup-close]').focus({preventScroll:true});
    };
    const close = () => { if (popup.open) popup.close(); };
    popup.querySelector('[data-willy-popup-close]').addEventListener('click', close);
    popup.addEventListener('click', (event) => {
      if (event.target !== popup) return;
      const rect = popup.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    popup.addEventListener('close', () => {
      clearTimeout(timer);
      document.body.style.overflow = previousOverflow;
      remember();
      if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    });
    popup.querySelector('form')?.addEventListener('submit', (event) => {
      if (!event.currentTarget.checkValidity()) return;
      clearTimeout(timer);
    });
    if (result || !dismissed) timer = setTimeout(open, result ? 0 : (Number(popup.dataset.delay) || 15) * 1000);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
